import globalization, { commonNs } from './index';
import NamespaceManager from './namespaceManager';

let vueNsManager = new NamespaceManager();

Object.assign(vueNsManager, {
    addVm(vm) {
        let { ns, translationResourcesLoaded } = vm.$options.i18next;
        if (!ns && !translationResourcesLoaded) {
            return;
        }
        vueNsManager.addNamespace(vm, ns);
        let startNs = [...commonNs];
        if (ns) {
            startNs = startNs.concat(ns);
        }
        return globalization.loadNs(startNs).then(_ => {
            vm.langKey.id = Date.now();
            translationResourcesLoaded?.call(vm);
        });
    },
    removeVm(vm) {
        vueNsManager.removeNamespace(vm);
    },
    languageChangedCallback() {
        vueNsManager.keys.map(vm => {
            vm.langKey.id = Date.now();
            vm.$options.i18next.translationResourcesLoaded?.call(vm);
        });
    }
});

globalization.registerNamespaceManager(vueNsManager);

function install(Vue) {
    Vue.mixin({
        i18next: {
            //如果使用数组，不同命名空间会有同名属性覆盖的问题
            ns: ''
        },
        beforeCreate() {
            this.langKey = Vue.observable({ id: 0 });
            vueNsManager.addVm(this);
        },
        beforeDestory() {
            vueNsManager.removeVm(this);
        },
        methods: {
            $t(key, ...args) {
                if (!key) {
                    return;
                }
                this.langKey.id;
                const nsKey = key.split(':');
                if (nsKey.length > 1) {
                    //key中带有命名空间
                    return globalization.$t(key, ...args);
                }
                return globalization.$st(
                    this.$options.i18next.ns,
                    key,
                    ...args
                );
            },
            /**
             *
             * @param {命名空间，字符串或数组} ns
             * @param  {key(不能带有命名空间 ), options} args
             * @returns
             */
            $st(ns, key, ...args) {
                return globalization.$st(ns, key, ...args);
            },
            /**
             * 等待ns国际化资源加载完毕
             * @returns Promise
             */
            waitForLangNs() {
                let { ns } = this.$options.i18next;
                return globalization.loadNs(ns);
            }
        }
    });
}

export default install;
